<script>
export default {
    name: "PharmacyIssueReport",

    data() {

        return {
            filter: {
                from: this.$moment().format(`YYYY-MM-DD`),
                to: this.$moment().format(`YYYY-MM-DD`),
                storeId: 0,
                itemId: 0,
                itemName: ``,
            },
            stores: [],
            outpatientsummary: [],
            itemIssueHistory: [],
            viewItemHistory: false,
            item: {},
            searchItem: false,
            items: [],
        };
    },

    mounted() {

        this.$root.loading = true;
        Promise.all([ this.fetchIssueReport(),this.fetchStores(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {
        fetchStores() {

return this.$http.get(`Shared/GetStoreLocations`).then(({ data }) => {
    this.stores = data;
}).catch(() => {});
},
        fetchSearchedItems() {
            if(!this.filter.itemName) return Promise.reject();

            let url = `Shared/GetSearchItems`;
                url += `?SearchItems=${this.filter.itemName}`;
            this.$root.loading = true;
            return this.$http.get(url).then(({ data}) => {
                this.items = data;
                this.$root.loading = false;
                this.searchItem = true;
            }).catch(() => { this.$root.loading = false; });
        },

        fetchIssueReport() {
            let url = `Pharmacy/GetOutPatientPharmacySummary`;
                url += `?Datefrom=${this.filter.from}`;
                url += `&Dateto=${this.filter.to}`;
                //url += `&StoreId=${this.filter.storeId}`;
                url += this.filter.itemId ? `&ItemId=${this.filter.itemId}` : ``;

            return this.$http.get(url).then(({ data }) => {
                this.outpatientsummary = data;
            }).catch(() => {});
        },

        fetchItemIssueHistory(item) {
            this.$root.loading = true;
            let url = `Pharmacy/GetPatientDrugIssueReport`;
                url += `?FromDate=${this.filter.from}`;
                url += `&ToDate=${this.filter.to}`;
                url += `&ItemId=${item.serviceId}`;

            return this.$http.get(url).then(({ data }) => {
                this.item = item;
                this.itemIssueHistory = data;
                this.$root.loading = false;
                this.viewItemHistory = true;
            }).catch(() => { this.$root.loading = false; });
        },
        printoupatientReport() {
            let url = `/reports/pharmacy/outpatientsummary-report/print`;
                url += `?Datefrom=${this.filter.from}&Dateto=${this.filter.to}`;
                url += this.filter.itemId ? `&ItemId=${this.filter.itemId}` : ``;
               
            window.open(
                url,
                '_blank', `ReportPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },

    // components: {
    //     'item-issue-history': () => import('./modals/ItemIssueHistory.vue')
    // },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Report: Pharmacy Drug Issue</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.from" 
                    id="grid-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.to" 
                    id="grid-to" class="input-control input-sm text-xs">
              </div>
               <!-- <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-item-name" class="label-control">Item:</label>
                  <input type="text" v-model.trim="filter.itemName" 
                    @keydown.enter="fetchSearchedItems"
                    id="grid-item-name" class="input-control input-sm text-xs">
                <tail-drug-select 
                    :showModal="searchItem"
                    :items="items"
                    @closeModal="searchItem=false"
                    @itemSelected="(item) => {
                        filter.itemName = item.itemName;
                        filter.itemId = item.itemID;
                        searchItem = false;
                    }"
                />
              </div> -->
              <div class="md:w-2/12 sm:w-full p-tiny mt-3">
                  <button 
                    @click.prevent="() => {
                        $root.loading = true;
                        fetchIssueReport().then(() => {
                            $root.loading = false;
                        });
                    }"
                    class="btn-sm btn-info text-xs rounded mr-2">
                      <i class="fa fa-search"></i> Filter
                  </button>
                  <!-- <button
                    @click.prevent="() => {
                        filter.itemId = 0;
                        filter.itemName = ``;
                    }"
                    class="btn-sm btn-danger text-xs rounded">
                      <i class="fa fa-times"></i> Clear
                  </button> -->
              </div>
              <!-- <item-issue-history 
                :itemIssueHistory="itemIssueHistory"
                :showModal="viewItemHistory"
                :item="item"
                @closeModal="() => {
                    viewItemHistory = false;
                    itemIssueHistory = [];
                    item = {};
                }"
              /> -->
          </div>
       <!-- Start of outpatient summary -->
          <div class="w-full overflow-auto">
        
        <table class="table">
               <tr class="flex w-full" v-for="(patient, idx) in outpatientsummary.outPatientListPharmacy" :key="idx">
                  
            <table class="table">
            <thead class="bg-blue-500 text-sm">
                <tr class="flex text-white w-full bg-gray-500">
                    <!-- <th class="p-tiny w-full"> {{ patient }}</th> -->
                    <th class="p-tiny  w-1/6">MRN:  {{ patient.patienT_ID }}</th>
                    <th class="p-tiny w-full"> NAME: {{ patient.names }}</th>
                    <th class="p-tiny  w-1/4"> DATE:  {{ patient.visitDate | dateFormat}}</th>
                    <th class="p-tiny  w-1/6"> AGE:  {{ patient.age }}</th>
                    <th class="p-tiny w-full"> DIAGNOSIS:  {{ patient.diagnosis }}</th>
                   
                   
                    
                    
                </tr>
                <tr class="flex text-white w-full">
                    <th class="p-tiny w-1/6">Date</th>
                    <th class="p-tiny w-1/3">Item Name</th>
                    <th class="p-tiny w-1/6">Precription</th>
                    <th class="p-tiny w-1/6">Processed</th>
                    <th class="p-tiny w-1/6">Dosage Qty</th>
                    <th class="p-tiny w-1/6">Qty Issued</th>
                    <th class="p-tiny w-1/6">Qty Remaining</th>
                   <th class="p-tiny w-1/6">Requested By</th>
                    <th class="p-tiny w-1/6">Processed By</th>
                    <th class="p-tiny w-1/6">Payment</th>
                    <th class="p-tiny w-1/6">Payment Ref</th>
                   
                </tr>
            </thead>
           
            <tbody class="text-sm font-semibold bg-gray-100 flex flex-col items-center overflow-auto w-full" 
                >
                <tr class="flex w-full" v-for="(prescription, idx) in  outpatientsummary.outPatientPrescriptions.filter(g=>g.visitNo==patient.visitNo)" :key="idx">
                   
                    <td class="p-tiny w-1/6">{{ prescription.date | dateFormat }}</td>
                    <td class="p-tiny w-1/3">{{ prescription.service }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.prescription }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.isProcessed }}</td>
                   <td class="p-tiny w-1/6">{{ prescription.dosage }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.issuedQty }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.remainingDOsage }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.requestedBy }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.processedBy }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.payment }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.paymentRefNo }}</td>
                    
                     
                </tr>
            </tbody>
        </table>
    </tr>
</table>
    </div>
    <!-- end of preview -->
         
        </template>
        <template v-slot:card-footer>
            <div class="w-full text-right">
                <button class="btn-sm btn-primary text-xs rounded" 
                    @click.prevent="printoupatientReport">
                        <i class="fa fa-print"></i> Print</button>
            </div>
        </template>   </tail-card>
  </template>
</tail-base-layout>
</template>